import { motion } from "framer-motion";
import aboutMain from "../Img/about_section_fin.png";

const scrollReveal = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.4 } },
};

const AboutMainSection = () => {
  return (
    <motion.div
      className="about-main-section-smco"
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <motion.div
        className="about-main-container-smco"
        variants={staggerContainer}
      >
        <motion.div className="about-main-left-smco" variants={scrollReveal}>
          <motion.img
            src={aboutMain}
            alt="KRS FinSolutions - Financial Advisory, Consultancy & Compliance"
            variants={scrollReveal}
            className="animate__animated animate__zoomInLeft"
          />
          <motion.div
            className="about-main-left-border-smco animate__animated animate__zoomInLeft"
            variants={scrollReveal}
          ></motion.div>
        </motion.div>
        <motion.div
          className="about-main-right-smco"
          variants={staggerContainer}
        >
          <motion.h2 className="sections-title-smco" variants={scrollReveal}>
            <span className="horizontal-line"></span>About KRS FinSolutions
          </motion.h2>
          <motion.p
            className="about-main-right-text-smco"
            variants={scrollReveal}
          >
            Precision in Audit • Excellence in Advisory • Growth in Partnership{" "}
            <br />
            Incorporated in 2021, KRS FinSolutions was founded on the principle
            that financial clarity is the ultimate catalyst for business growth.
            In an era of complex regulations and shifting market dynamics, we
            serve as a strategic anchor for enterprises, providing the technical
            precision of a traditional audit firm with the forward-thinking
            agility of a modern consultancy.
            <br />
            We don’t just 'crunch numbers'—we build the financial hygiene
            necessary for valuation, scalability, and long-term investor
            confidence.
          </motion.p>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default AboutMainSection;
